import APIClient from "@axioscode/api-client";
import { OAUTH, BACKEND_ROOT } from "config/constants";
import { finishOAuthFlow } from "auth/actions";

/**
 * Return an instance of our API Client
 * @param {function} dispatch redux's dispatch function
 * @param {function} getState returns the redux store's current state
 */
export default function(dispatch, getState) {
  return new APIClient({
    token: getState().token,
    clientId: OAUTH.CLIENT_ID,
    scopes: OAUTH.SCOPES,
    authCallback: tokenURI => dispatch(finishOAuthFlow(tokenURI)),
    backendRoot: BACKEND_ROOT,
  });
}
